import type { Holding } from '../types/Holding'

export enum AnalysisType {
  Stocks = 'stocks',
  Bonds = 'bonds',
}

// The nine Morningstar allocation weights on a holding. Order is significant:
// it maps positionally to the `allocations_list` copy display names.
export const ALLOCATION_KEYS = [
  'allocations_cash',
  'allocations_convertible',
  'allocations_foreign_bond',
  'allocations_foreign_stock',
  'allocations_other',
  'allocations_preferred',
  'allocations_us_bond',
  'allocations_us_stock',
  'allocations_unknown',
] as const satisfies readonly (keyof Holding)[]

export type AllocationKey = (typeof ALLOCATION_KEYS)[number]

// The ten style-box weights (equity + fixed-income share the same buckets).
export const STYLE_WEIGHT_KEYS = [
  'large_core_weight',
  'large_growth_weight',
  'large_value_weight',
  'mid_core_weight',
  'mid_growth_weight',
  'mid_value_weight',
  'small_core_weight',
  'small_growth_weight',
  'small_value_weight',
  'unknown_weight',
] as const satisfies readonly (keyof Holding)[]

export const EquityClassificationTypes = {
  UNKNOWN: 0,
  LARGE_VALUE: 1,
  LARGE_CORE: 2,
  LARGE_GROWTH: 3,
  MID_VALUE: 4,
  MID_CORE: 5,
  MID_GROWTH: 6,
  SMALL_VALUE: 7,
  SMALL_CORE: 8,
  SMALL_GROWTH: 9,
}

export const EquityClassificationValues = {
  0: 'UNKNOWN',
  1: 'LARGE_VALUE',
  2: 'LARGE_CORE',
  3: 'LARGE_GROWTH',
  4: 'MID_VALUE',
  5: 'MID_CORE',
  6: 'MID_GROWTH',
  7: 'SMALL_VALUE',
  8: 'SMALL_CORE',
  9: 'SMALL_GROWTH',
}

export const FixedIncomeClassificationTypes = {
  UNKNOWN: 0,
  HIGH_LIMITED: 1,
  HIGH_MODERATE: 2,
  HIGH_EXTENSIVE: 3,
  MEDIUM_LIMITED: 4,
  MEDIUM_MODERATE: 5,
  MEDIUM_EXTENSIVE: 6,
  LOW_LIMITED: 7,
  LOW_MODERATE: 8,
  LOW_EXTENSIVE: 9,
}

export const FixedIncomeClassificationValues = {
  0: 'UNKNOWN',
  1: 'HIGH_LIMITED',
  2: 'HIGH_MODERATE',
  3: 'HIGH_EXTENSIVE',
  4: 'MEDIUM_LIMITED',
  5: 'MEDIUM_MODERATE',
  6: 'MEDIUM_EXTENSIVE',
  7: 'LOW_LIMITED',
  8: 'LOW_MODERATE',
  9: 'LOW_EXTENSIVE',
}
